require('./bootstrap')
import { Fancybox } from "@fancyapps/ui"

//import 'livewire-turbolinks';

// require('jquery-ui/ui/widgets/autocomplete')
// require('jquery-ui/ui/widgets/datepicker')
// require('jquery-ui/ui/i18n/datepicker-ru')
// $.datepicker.setDefaults($.datepicker.regional['ru'])
